import * as constants from './constants'

export const requestConfiguration = language => ({
    type: constants.REQUEST_CONFIGURATION,
    language,
})

export const configurationReceived = configuration => ({
    type: constants.CONFIGURATION_RECEIVED,
    configuration,
})

export const fetchPosts = (kind, postIDs) => ({
    type: constants.FETCH_POSTS,
    kind,
    postIDs,
})

export const queryPosts = (kind, params = {}, requestId) => ({
    type: constants.QUERY_POSTS,
    kind,
    params,
    requestId,
})

export const queryNews = (...args) => queryPosts('news', ...args)

export const postsReceived = (posts, kind, requestId) => ({
    type: constants.POSTS_RECEIVED,
    ...posts,
    kind,
    requestId,
})

export const sendFeedback = data => ({
    type: constants.SEND_FEEDBACK,
    data,
})

export const submitForm = data => ({
    type: constants.SUBMIT_FORM,
    data,
})

export const subscribeNews = email => ({
    type: constants.REQUEST_SUBSCRIBE_NEWS,
    email,
})

export const subscribeNewsSucceeded = message => ({
    type: constants.SUBSCRIBE_NEWS_SUCCEEDED,
    message,
})

export const subscribeOffers = email => ({
    type: constants.REQUEST_SUBSCRIBE_OFFERS,
    email,
})

export const subscribeOffersSucceeded = message => ({
    type: constants.SUBSCRIBE_OFFERS_SUCCEEDED,
    message,
})
